/**
 * Given the current path and the application's routes, compute the routes' arborescence.
 * The computation is based on the fact that routes' arborescence follows the rule that nested routes share the same url base as their parents.
 * @param {String} currentPath Current path in the router
 * @param {Object} routes Object where each key is a route in the application with an url attribute
 * @returns {Array.<Object>} Array of routes sorted to display the breadcrumb
 */
module.exports = (currentPath, routes) => Object.keys(routes)
    // From route keys
    // Filter out routes that do not share the same path that the current path
    .filter(routeKey => routes[routeKey].url && currentPath.indexOf(routes[routeKey].url) === 0)
    // Map to the route object
    .map(routeKey => routes[routeKey])
    // Sort them by nested levels : "/" > "/users" > "/users/:userId" > "/users/:userId/subResource"
    .sort((routeA, routeB) => routeA.url.length < routeB.url.length ? -1 : 1);
